export default {
  Title: 'Client Metrics',
  Subtitle: 'Calendar-month financial snapshot — previous, current, and next month.',
  DatePickerLabel: 'Select snapshot date',
  GeneratedAt: 'Snapshot generated #{timestamp}',
  MetricDate: 'Snapshot date: #{date}',
  Unavailable: '--',
  NotApplicable: 'Not applicable',
  MarginPoints: '#{value} pts',
  Errors: {
    LoadError: 'Unable to load client metrics right now.',
    Retry: 'Try again',
  },
  EmptyStates: {
    MissingSnapshot: 'No monthly financial snapshot is available for #{date}. It may not have been generated yet.',
    PredatesSystem: 'No monthly financial snapshot is available for #{date}. Dates before the monthly dashboard was deployed are not available.',
  },
  SnapshotHeader: {
    SectionTitle: 'SNAPSHOT',
    Previous: 'Previous month',
    Current: 'Current month',
    Next: 'Next month',
    PeriodRange: '#{startDate} – #{endDate}',
    ActualThrough: 'Actual through #{date}',
    ScheduledOnly: 'Scheduled forecast only',
    Timezone: 'Months derived in #{timezone}',
  },
  Overview: {
    SectionTitle: 'MONTHLY OVERVIEW',
    Previous: 'Previous month',
    Current: 'Current month',
    Next: 'Next month',
    Scheduled: 'Scheduled',
    Actual: 'Actual',
    Variance: 'Variance',
    VarianceLabel: '#{metric} variance #{value}',
    FullMonth: 'Scheduled & actual',
    ScheduledOnly: 'Scheduled only',
    ActualThrough: 'Actual through #{date}',
    Metric: 'Metric',
    Metrics: {
      ClientHours: 'Client hours',
      ClientWeightedHours: 'Client weighted hours',
      CaregiverHours: 'Caregiver hours',
      CaregiverWeightedHours: 'Caregiver weighted hours',
      Revenue: 'Revenue',
      LaborCost: 'Caregiver labour',
      GrossProfit: 'Gross profit',
      ClientCount: 'Clients',
      CaregiverCount: 'Caregivers',
      Expenses: 'Expenses',
    },
  },
  Kpis: {
    SectionTitle: 'ANNUALIZED RUN-RATE',
    Subtitle: 'Annualized from the current month\'s scheduled forecast (× 12).',
    AnnualizedRevenue: 'ANNUALIZED REVENUE',
    AnnualizedProfit: 'ANNUALIZED GROSS PROFIT',
    AnnualRevenueAdded: 'ANNUAL REVENUE ADDED',
    AnnualRevenueAddedCaption: 'vs. previous month run-rate',
    RevenueGrowth: 'REVENUE GROWTH',
    RevenueGrowthCaption: 'vs. previous month',
    GrossMargin: 'GROSS MARGIN',
    GrossMarginCaption: 'Current month scheduled',
  },
  ClientMonthly: {
    SectionTitle: 'CLIENT BREAKDOWN',
    Title: 'Client breakdown',
    Subtitle: 'Per-client scheduled forecast and actuals for #{month}.',
    Periods: {
      Previous: 'Previous month',
      Current: 'Current month',
      Next: 'Next month',
    },
    PeriodSelectorLabel: 'Select the month to break down by client',
    Summary: {
      Clients: 'CLIENTS',
      ClientsWithHours: 'CLIENTS WITH SCHEDULED HOURS',
      ScheduledHours: 'SCHEDULED HOURS',
      ScheduledRevenue: 'SCHEDULED REVENUE',
      ActualHours: 'ACTUAL HOURS',
      ActualRevenue: 'ACTUAL REVENUE',
      MissingRates: 'CLIENTS MISSING RATE',
      UnpricedHoursCaption: '#{hours} hrs unpriced',
      NoUnpricedHours: 'All scheduled hours priced',
    },
    Table: {
      Client: 'Client',
      ScheduledRate: 'Sched. rate',
      ScheduledHours: 'Sched. hours',
      ScheduledWeightedHours: 'Sched. weighted',
      ScheduledRevenue: 'Sched. revenue',
      ActualHours: 'Actual hours',
      ActualRevenue: 'Actual revenue',
      ActualRate: 'Actual rate(s)',
      Status: 'Data quality',
      MissingRate: 'Missing rate',
      Unpriced: 'Unpriced',
      PartlyUnpriced: '#{hours} hrs unpriced',
      MultipleRates: 'Multiple',
      NoScheduledHours: 'No scheduled hours',
      Priced: 'Priced',
      TotalsRow: 'All clients',
      TotalsNote: 'Full snapshot',
      TotalsCaption: 'Totals reflect every client in the snapshot, not only the rows shown.',
      SearchPlaceholder: 'Search client or RN',
      ResultCount: 'Showing #{shown} of #{total}',
      RnTooltip: 'RN: #{rn}',
      SortActive: 'Sorted by #{column} #{direction}. Activate to change direction.',
      SortInactive: 'Activate to sort by #{column}.',
      SortAscending: 'ascending',
      SortDescending: 'descending',
    },
    LoadMore: 'Load more clients',
    Retry: 'Try again',
    Errors: {
      LoadError: 'Unable to load the client breakdown right now.',
    },
    EmptyStates: {
      NoClients: 'This snapshot has no clients for #{month}.',
      MissingSnapshot: 'No per-client snapshot is available for #{date}. ' +
        'Older dates may predate this feature, or the snapshot may not have been generated yet.',
    },
  },
  DataQuality: {
    SectionTitle: 'DATA QUALITY',
    Intro: 'Backend-reported issues that may affect the figures above.',
    Previous: 'Previous month',
    Current: 'Current month',
    Next: 'Next month',
    Snapshot: 'Snapshot-wide',
    PeriodClean: 'No issues reported.',
    MissingClientRates: 'Missing client rates',
    MissingCaregiverRates: 'Missing caregiver rates',
    UnpricedHours: 'Unpriced scheduled hours',
    UnassignedEvents: 'Unassigned scheduled events',
    SkippedEvents: 'Skipped schedule records',
    MissingActuals: 'Actual data unavailable for this period',
    CountValue: '#{count}',
    CountHoursValue: '#{count} · #{hours} hrs affected',
    HoursValue: '#{hours} hrs',
    UnassignedValue: '#{count} · #{revenue}',
    SkippedReasonItem: '#{reason}: #{count}',
  },
};
